import React, { useEffect, useState } from 'react';
import APIService from '../../Services/APIService';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import {
  B2b2cFormErrorAtom,
  dynamicLeadFormAtom,
  formEnableDisableAtom,
  knowlarityApiResponseAtom,
  // isLeadFormValidateAtom,
  leadAllCountsAtom,
  leadDetailObjAtom,
  leadFormQuickTemplateAtom,
  phoneNumberAllLeadsAtom,
  referenceFieldAtom,
  userInfoByNumberAtom,
  userInfoFormEnableDisableAtom,
  userRawLeadFormDataAtom,
} from '../../Services/_states/LeadForm';
import {
  channelListAtom,
  interveneFilterAtom,
  userDetailAtom,
  userInformationAtom,
} from '../../Services/_states';
import SweetAlert from '../Shared/Notification';
import ChatBox from './chatBox.tsx';
import { QuickTemplateModal } from './QuickTemplateModal/quickTemplateModal';
import { ConstantActions, LeadFormActions } from '../../Services/_actions';
import { CallingModal } from '../Modals/CallingModal/CallingModal';
import SendTemplateModal from '../Modals/SendTemplateModal';
import { InterveneActions } from '../../Services/_actions/Intervene/intervene.actions';
import { DispositionModal } from '../Modals/DispositionModal';
import RecordingTimer from './RecordingTimer';
import KnowlarityModal from '../Modals/KnowlarityModal/index.tsx';
import SelectDropdown from '../Shared/SelectDropdown';
import { useSnackBar } from '../FlowBuilder/Common/SnackBar/index.tsx';
import {
  Box,
  Button,
  Alert as MUIAlert,
  Grid,
  Typography,
  Paper,
  Snackbar,
  IconButton,
  useMediaQuery,
} from '@mui/material';
import ModalForms from '../../components/Shared/Modals';
import { validateFormFieldValue } from '../Leads/DynamicFormFields/helper.ts';
import Header from './Header.tsx';
import MobileLeadLayout from './MobileLeadLayout.tsx';
import LeadsSection from './LeadsSection.tsx';
import DetailsSection from './DetailsSection.tsx';
import UserSection from './UserSection.tsx';
import { useParams } from 'react-router';

function LeadWebForm() {
  const leadFormActions = LeadFormActions();
  const constantActions = ConstantActions();
  const interveneActions = InterveneActions();
  const { showSnackBar } = useSnackBar();
  const channelList = useRecoilValue(channelListAtom);
  const [interveneFilters, setInterveneFilters] = useRecoilState(interveneFilterAtom);
  const leadWebFormData = JSON.parse(localStorage.getItem('leadWebFormData'));
  const formFields = leadWebFormData?.webForm?.leads_form_items;
  const [dynamicLeadForm, setDynamicLeadForm] = useRecoilState(dynamicLeadFormAtom);
  const setReferences = useSetRecoilState(referenceFieldAtom);
  const [userDetails, setUserDetails] = useRecoilState(userDetailAtom);
  const loggedInUser = useRecoilValue(userInformationAtom);
  const setleadCounts = useSetRecoilState(leadAllCountsAtom);
  const [formEnable, setFormEnable] = useRecoilState(formEnableDisableAtom);
  const [leadDetails, setLeadDetail] = useRecoilState(leadDetailObjAtom);
  const [validationErrors, setValidationErrors] = useRecoilState(B2b2cFormErrorAtom);
  const [userDetailByNumber, setUserDetailByNumber] = useRecoilState(userInfoByNumberAtom);
  const [userInfoFormEnable, setUserInfoFormEnable] = useRecoilState(userInfoFormEnableDisableAtom);
  const knowlarityApiResData = useRecoilValue(knowlarityApiResponseAtom);
  const [showQuickTempModal, setShowQuickTempModal] = useState(false);
  const [modalShow_temp, setModalShow_temp] = useState(false);
  const [modalShow_call, setModalShow_call] = useState(false);
  const [leadFormTemplate, setLeadFormTemplate] = useRecoilState(leadFormQuickTemplateAtom);
  const [showChatBox, setShowChatBox] = useState(false);
  const [showNotepad, setShowNotepad] = useState(true);
  const [missingFields, setMissingFields] = useState([]);
  const [openValidationModal, setOpenValidationModal] = useState(false);
  const [audioModalShow, setAudioModalShow] = React.useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [dispositionModalShow, setDispositionModalShow] = useState(false);
  const [formDataLoading, setFormDataLoading] = useState(false);
  const [userRawLeadData, setUserRawLeadData] = useRecoilState(userRawLeadFormDataAtom);
  const [paginatedAllLeadsData, setPaginatedAllLeadsData] = useRecoilState(phoneNumberAllLeadsAtom);
  const [dynamicFormData, setDynamicFormData] = useState({});
  const [fieldErrors, setFieldErrors] = useState({});
  const [statusUpdate, setStatusUpdate] = useState({});
  const { phone_number, leadId } = useParams();
  const leadIds = leadDetails?.id || userDetailByNumber?.leadId || leadId || '';
  const [expanded, setExpanded] = useState(false);
  const [subExpanded, setSubExpanded] = useState(false);
  const isMobile = useMediaQuery('(max-width:768px)');
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleSubChange = (panel) => (event, isExpanded) => {
    setSubExpanded(isExpanded ? panel : false);
  };

  const normalizeDynamicFormData = (input) => {
    if (Array.isArray(input)) {
      const out = {};
      input.forEach((group) => {
        if (group && typeof group === 'object') {
          const key = Object.keys(group)[0];
          if (key) out[key] = group[key];
        }
      });
      return out;
    }
    return input || {};
  };

  const transcript = [
    {
      sender: 'Person 2',
      message: 'Okay, I’ll forward this to the IT team and update you soon.',
    },
    {
      sender: 'Person 4',
      message: 'Thanks, please let me know once it’s resolved.',
    },
    {
      sender: 'Person 1',
      message: 'Sure, will do.',
    },
  ];
  const validateFormData = () => {
    let data = [];
    Object.values(dynamicFormData || {}).forEach((groupItems) => {
      data = data.concat(groupItems);
    });
    const filteredData = data.filter((item) => !Boolean(item?.is_static_column));

    let missingFields = [];
    let errors = {};

    for (let i in filteredData) {
      if (!filteredData[i]?.value && filteredData[i]?.key_name !== 'Q2. Designation') {
        if (filteredData[i]?.isRequired) {
          errors[filteredData[i]?.key_name] = 'This Field is required';
          missingFields.push({ keyName: filteredData[i]?.key_name, isRequired: true });
        } else {
          missingFields.push({ keyName: filteredData[i]?.key_name, isRequired: false });
        }
      }
    }

    setValidationErrors(errors);
    setMissingFields(missingFields);

    if (missingFields?.length > 0) {
      setOpenValidationModal(true);
    } else {
      saveForms();
    }
  };

  const findTitleById = (id, options) => {
    const item = options.find((item) => item.id === id);
    return item?.title || 'Details';
  };

  const groupLeadItems = (leadArray, groupOptions, userRawLeadData = null) => {
    const grouped = {};

    leadArray.forEach((originalItem) => {
      let item = originalItem;

      if (userRawLeadData) {
        const userData = userRawLeadData.data?.find(
          (dataItem) => dataItem.alias_name === originalItem.alias_name
        );
        if (userData && !originalItem.value) {
          item = { ...originalItem, value: userData.value }; // Create a new object
        }
      }

      const title = findTitleById(item.groupId, groupOptions);
      if (!grouped[title]) {
        grouped[title] = [];
      }
      grouped[title].push(item);
    });

    return Object.entries(grouped).map(([groupId, items]) => ({ [groupId]: items }));
  };

  const getCampaignLeadAliasData = async (campaignId) => {
    setFormDataLoading(true);
    try {
      const res = await leadFormActions.getFormsByCampaignId(campaignId);
      const formId = userDetailByNumber?.leadform_Id;
      const data = res?.data?.[formId];

      if (!data) throw new Error('Invalid Form Id');
      const leadItems = Object.values(data.leads_form_items || {});
      const groupOptions = data.group_options || [];
      const groupedForm = groupLeadItems(leadItems, groupOptions);

      setLeadFormTemplate(data.templates);
      setDynamicLeadForm(groupedForm);
    } catch {
      SweetAlert('Invalid Form Id', 'error');
    } finally {
      setFormDataLoading(false);
    }
  };

  const handleFieldChange = (index, value, groupTitle) => {
    const updatedData = { ...dynamicFormData };
    const groupForm = [...updatedData[groupTitle]];
    let updatedField = { ...groupForm[index], value: value };
    if (value && typeof value === 'object' && value?.collection === 'entity') {
      updatedField = { ...updatedField, entity_data: value ?? null, value: value?.value ?? '' };
    } else if (
      updatedField?.statusOption === 'is_status' ||
      updatedField?.statusOption === 'is_sub_status'
    ) {
      if (updatedField?.statusOption === 'is_status') {
        updatedField = {
          ...updatedField,
          status_config: value ?? null,
          value: value?.status_name ?? '',
        };
      } else if (updatedField?.statusOption === 'is_sub_status') {
        updatedField = { ...updatedField, status_config: value ?? null, value: value?.name ?? '' };
      }
      setStatusUpdate((prev) => {
        if (updatedField?.statusOption === 'is_status') {
          return {
            ...prev,
            status: {
              ...prev.status,
              [updatedField.key_name]: {
                status_id: value?.status_id ?? '',
                status_name: value?.status_name ?? '',
                type_of_status: value?.type_of_status ?? '',
                status: value?.status_name ?? '',
              },
            },
          };
        }
        if (updatedField?.statusOption === 'is_sub_status') {
          return {
            ...prev,
            sub_status: {
              ...(prev?.sub_status ?? {}),
              [updatedField.key_name]: {
                sub_status_id: value?.sub_status_id ?? '',
                sub_status_name: value?.name ?? '',
                type_of_status: value?.type_of_status ?? updatedField?.key_name ?? '',
                status_id: value?.status_id ?? '',
                status_name: value?.status_name ?? '',
              },
            },
          };
        }
      });
    }
    groupForm[index] = updatedField;
    updatedData[groupTitle] = [...groupForm];
    setDynamicFormData(updatedData);
    const errorMsg = validateFormFieldValue(updatedField, value);
    if (errorMsg) {
      setFieldErrors((prev) => ({ ...prev, [`${groupTitle}_${index}`]: errorMsg }));
    } else {
      setFieldErrors((prev) => {
        const { [`${groupTitle}_${index}`]: _, ...rest } = prev;
        return { ...rest };
      });
    }
  };

  const updateStatusInLoop = async (leadIds) => {
    if (!leadIds) return;

    try {
      const statusPayloads = [
        ...Object.values(statusUpdate?.status ?? {}),
        ...Object.values(statusUpdate?.sub_status ?? {}),
      ]
        ?.filter(
          (item) => Boolean(item) && item?.status_id && (item?.status_name || item?.sub_status_name)
        )
        ?.map((item) => ({
          ...item,
          id: leadIds,
        }));

      if (statusPayloads?.length === 0) {
        return;
      }

      const results = await Promise.allSettled(
        statusPayloads.map((payload) => leadFormActions.updateLeadStatusDate(payload))
      );

      results.forEach((res, idx) => {
        const status = statusPayloads[idx];
        const label = status.status_name || status.sub_status_name || 'unknown';

        if (res.status === 'fulfilled' && res.value?.status === 200) {
        } else {
          console.error(`❌ Failed to update ${label}`, res);
        }
      });
    } catch (err) {
      console.error('Unexpected error in updateStatusInLoop:', err);
    }
  };

  const uploadFileInS3 = async (files) => {
    let s3Link = '';
    // for (let i in files) {
    try {
      const file = files[0];
      if (file) {
        const formDataToUpload = new FormData();
        formDataToUpload.append('file', file);
        let resp = await constantActions.uploadFileS3Bucket(formDataToUpload);
        if (resp?.status === 200 && resp?.data?.data) {
          s3Link = resp?.data?.data?.url ?? '';
        }
      }
    } catch (error) {
      s3Link = '';
      console.error('Error uploading file:', error);
    }
    return s3Link;
  };

  const saveForms = async () => {
    setIsLoading(true);

    // Check phone number
    const phone = userDetailByNumber?.phone_number || userDetails?.phone_number;
    if (!phone) {
      SweetAlert('Phone number is required', 'error');
      setIsLoading(false);
      return;
    }

    // Get the most up-to-date lead ID from all possible sources
    const currentLeadId = leadDetails?.id || userDetailByNumber?.leadIds || '';
    const formId = userDetailByNumber?.leadform_Id;

    if (!formId) {
      SweetAlert('Form ID is missing', 'error');
      setIsLoading(false);
      return;
    }

    // Flatten dynamicFormData
    let allFields = [];
    Object.values(dynamicFormData).forEach((group) => {
      allFields = allFields.concat(group);
    });

    // Validate required fields
    const errors = {};
    const missingFields = [];
    allFields.forEach((item) => {
      if (item.isRequired && !item.value) {
        errors[item.key_name] = 'This field is required';
        missingFields.push(item.key_name);
      }
    });

    if (missingFields.length > 0) {
      setValidationErrors(errors);
      setMissingFields(missingFields);
      setOpenValidationModal(true);
      setIsLoading(false);
      return;
    }

    const updatedField = allFields?.filter((item) => !Boolean(item?.is_static_column));

    const entries = await Promise.all(
      updatedField?.map(async (item) => {
        if (item.file?.length) {
          const fileUrl = await uploadFileInS3(item.file);
          return { key_name: item?.key_name, value: fileUrl };
        }
        return { key_name: item?.key_name, value: item.value };
      })
    );

    // Prepare final data object
    const data = {
      supplier_id: userDetailByNumber?.supplier_id?.toString() || '',
      city: userDetailByNumber?.city || '',
      area: userDetailByNumber?.area || '',
      phone_number: phone,
      supplier_name: userDetailByNumber?.entity_name || '',
      contact_name: userDetailByNumber?.person_name || '',
      leads_form_entries: entries,
      internal_comment: leadDetails?.internal_comment || '',
    };

    try {
      // Use the most current lead ID
      const endpoint = currentLeadId
        ? `v0/ui/leads/${formId}/insert_lead?lead_id=${currentLeadId}`
        : `v0/ui/leads/${formId}/insert_lead`;

      const res = await APIService.post(endpoint, data);

      if (res?.status === 200) {
        // Update lead details with the response data if it's a new record
        if (res.data?.data?.lead_id && !currentLeadId) {
          setLeadDetail((prev) => ({ ...prev, id: res.data.data.lead_id }));
        }

        await updateStatusInLoop(currentLeadId || res.data?.data?.lead_id);

        showSnackBar('Lead saved successfully', 'success');

        // Refresh the lead data after successful save
        // if (userDetailByNumber?.phone_number) {
        //   await getUserDetailsByParams();
        // }
      } else {
        showSnackBar('Failed to save lead', 'error');
      }
    } catch (err) {
      console.error('Save error:', err);
      showSnackBar('Something went wrong', 'error');
    } finally {
      setIsLoading(false);
    }
  };

  const submitForms = async () => {
    await leadFormActions.updateQcStatus(leadDetails);
  };

  const editForms = () => {
    setFormEnable(!formEnable);
  };

  const updateUserDetail = async () => {
    if (!userDetailByNumber) {
      showSnackBar('User details are missing', 'error');
      return;
    }
    const data = {
      company_id: userDetailByNumber?.company_id,
      data: userRawLeadData?.data,
      form_id: userDetailByNumber?.form_id,
      phone_number: userDetailByNumber?.phone_number,
    };

    try {
      let res;
      if (userRawLeadData?.isCreateNewUser) {
        res = await leadFormActions.createUserDetail(data);
        if (res?.status === 200) {
          setUserInfoFormEnable(true);
          setUserRawLeadData({ ...userRawLeadData, isCreateNewUser: false });
          showSnackBar('User Created successfully', 'success');
        } else if (res?.data?.data?.general_error) {
          showSnackBar(res.data.data.general_error, 'error');
        } else {
          showSnackBar('User not created successfully', 'error');
        }
      } else {
        res = await leadFormActions.updateUserDetail(data);
        if (res?.status === 200) {
          showSnackBar('Information updated successfully', 'success');
          setUserInfoFormEnable(true);
        } else if (res?.data?.data?.general_error) {
          showSnackBar(res.data.data.general_error, 'error');
        } else {
          showSnackBar('Information not updated successfully', 'error');
        }
      }
    } catch (error) {
      showSnackBar('Something went wrong', 'error');
    }
  };

  const getAllChannels = async () => {
    await interveneActions?.getAllChannels();
  };

  useEffect(() => {
    if (channelList?.length >= 1) {
      setInterveneFilters({
        ...interveneFilters,
        channelObj: channelList[0],
        botNumber: channelList[0]['channel_number'],
      });
    }
  }, [channelList]);

  // useEffect(() => {
  //   if (leadDetails?.id) setFormEnable(true);
  //   else setFormEnable(false);
  // }, [leadFormTemplate]);

  useEffect(() => {
    if (dynamicLeadForm) {
      setDynamicFormData(normalizeDynamicFormData(dynamicLeadForm));
    }
  }, [dynamicLeadForm]);

  // Load default form from localStorage when campaign/form is already selected
  useEffect(() => {
    try {
      const stored = localStorage.getItem('leadWebFormData');
      if (!stored) return;
      const leadWebFormData = JSON.parse(stored) || {};
      const localForm = leadWebFormData?.webForm;

      if (!localForm?.leads_form_items) return;
      if (dynamicLeadForm?.length > 0) return;

      const leadItems = Object.values(localForm.leads_form_items || {});
      const groupOptions = localForm.group_options || [];
      const groupedForm = groupLeadItems(leadItems, groupOptions);

      setDynamicLeadForm(groupedForm);
      setLeadFormTemplate(localForm.templates || []);
      if (localForm.reference) setReferences(localForm.reference);

      if (leadWebFormData?.campaign?.proposal_id && localForm?.leads_form_id) {
        setUserDetailByNumber((prev) => ({
          ...prev,
          leadform_Id: localForm.leads_form_id,
          campaign_id: leadWebFormData.campaign.proposal_id,
          phone_number: leadWebFormData.phoneNumber || prev?.phone_number || '',
        }));
      }
    } catch (error) {
      console.warn('Error loading form data from localStorage:', error);
    }
  }, []);

  useEffect(() => {
    getAllChannels();
  }, []);

  const fetchVarient = (type) => {
    switch (type) {
      case 'AGENT_CALL':
      case 'AGENT_ANSWER':
      case 'CUSTOMER_CALL':
        return 'warning';
      case 'CUSTOMER_ANSWER':
        return 'success';
      case 'HANGUP':
        return 'danger';
      default:
        return '';
    }
  };
  function generateUUIDWithTimestamp() {
    const timestamp = Date.now().toString(16);
    return `${timestamp.slice(0, 8)}-xxxx-4xxx-yxxx-${timestamp.slice(8)}xxxx`.replace(
      /[xy]/g,
      function (c) {
        const r = (Math.random() * 16) | 0,
          v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }

  const saveCallDataObj = async () => {
    const currentTime = new Date();
    if (!userDetails?.phone_number) {
      SweetAlert('Phone number is not found', 'warning');
      return 0;
    }
    if (!loggedInUser?.mobile) {
      SweetAlert('Agent number is not found', 'warning');
      return 0;
    }

    let data = {
      ...knowlarityApiResData,
      dispnumber: '',
      timezone_offset: '+0000',
      business_call_type: 'Manual Dial',
      caller_id: `+91${userDetails?.phone_number || ''}`,
      Call_Type: 'Outgoing',
      uuid: generateUUIDWithTimestamp(),
      call_duration: 0,
      destination: `+91${loggedInUser?.mobile || ''}`,
      end_time: currentTime,
      resource_url: '',
      type: 'CDR',
      start_time: currentTime,
      agent_number: loggedInUser?.mobile || '',
      end_customer_number: userDetails?.phone_number || '',
    };
    await leadFormActions.postInterveneCdrData(data);
  };

  return (
    <Box>
      {isMobile ? (
        <MobileLeadLayout
          dynamicFormData={dynamicFormData}
          handleFieldChange={handleFieldChange}
          fieldErrors={fieldErrors}
          loggedInUser={loggedInUser}
          phoneNumber={userDetailByNumber?.phone_number || userDetails?.phone_number}
          formEnable={formEnable}
          isLoading={isLoading}
          editForms={editForms}
          validateFormData={validateFormData}
          setShowQuickTempModal={setShowQuickTempModal}
          setDispositionModalShow={setDispositionModalShow}
          leadFormTemplate={leadFormTemplate}
          updateUserDetail={updateUserDetail}
          setAudioModalShow={setAudioModalShow}
          setModalShow_call={setModalShow_call}
          setModalShow_temp={setModalShow_temp}
          setShowChatBox={setShowChatBox}
          setShowNotepad={setShowNotepad}
          setUserInfoFormEnable={setUserInfoFormEnable}
          userInfoFormEnable={userInfoFormEnable}
          showChatBox={showChatBox}
        />
      ) : (
        <Box>
          <Box mb={2}>
            <Header />
          </Box>
          {knowlarityApiResData?.type && (
            <Box mb={2}>
              <MUIAlert severity={fetchVarient(knowlarityApiResData?.type)}>
                {knowlarityApiResData?.type === 'AGENT_CALL' ? (
                  `Call Successfully Placed to Agent:- ${knowlarityApiResData?.agent_number}`
                ) : knowlarityApiResData?.type === 'AGENT_ANSWER' ? (
                  `Call Received by Agent :- ${knowlarityApiResData?.customer_number}`
                ) : knowlarityApiResData?.type === 'CUSTOMER_CALL' ? (
                  `Connecting Agent to Customer :- ${knowlarityApiResData?.customer_number}`
                ) : knowlarityApiResData?.type === 'CUSTOMER_ANSWER' ? (
                  <>
                    Call Connected :- {knowlarityApiResData?.customer_number} (<RecordingTimer />)
                  </>
                ) : knowlarityApiResData?.type === 'HANGUP' ? (
                  'Call Disconnected'
                ) : (
                  ''
                )}
              </MUIAlert>
            </Box>
          )}
          <Grid container spacing={2}>
            <Grid item sm={4}>
              <LeadsSection />
            </Grid>
            <Grid item sx={{ transition: '0.1s' }} sm={showChatBox || showNotepad ? '4' : '8'}>
              <DetailsSection
                formDataLoading={formDataLoading}
                dynamicFormData={dynamicFormData}
                loggedInUser={loggedInUser}
                handleFieldChange={handleFieldChange}
                fieldErrors={fieldErrors}
                formEnable={formEnable}
                userDetailByNumber={userDetailByNumber}
                userDetails={userDetails}
                isLoading={isLoading}
                validateFormData={validateFormData}
                editForms={editForms}
                leadFormTemplate={leadFormTemplate}
                setShowQuickTempModal={setShowQuickTempModal}
                setDispositionModalShow={setDispositionModalShow}
                showNotepad={showNotepad}
                setShowNotepad={setShowNotepad}
                showChatBox={showChatBox}
                setShowChatBox={setShowChatBox}
              />
            </Grid>

            {showNotepad && (
              <Grid
                item
                sm={4}
                sx={{ opacity: showChatBox || showNotepad ? 1 : 0, transition: 'all 1s ease' }}
              >
                <UserSection
                  updateUserDetail={updateUserDetail}
                  setAudioModalShow={setAudioModalShow}
                  setModalShow_call={setModalShow_call}
                  setModalShow_temp={setModalShow_temp}
                  setUserInfoFormEnable={setUserInfoFormEnable}
                  userInfoFormEnable={userInfoFormEnable}
                  setShowChatBox={setShowChatBox}
                  showChatBox={showChatBox}
                />
              </Grid>
            )}
          </Grid>
        </Box>
      )}
      {showNotepad && (
        <Grid className="chat-conversation position-relative">
          <Grid
            item
            xs={12}
            sm={6}
            md={8}
            lg={9}
            className="chat-card position-absolute top-0 end-0"
          >
            <Snackbar
              open={showChatBox}
              autoHideDuration={3000}
              onClose={() => setShowChatBox(false)}
              anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
              sx={{
                '&.MuiSnackbar-root': {
                  top: '118px',
                  right: '110px',
                },
              }}
            >
              <Paper elevation={4} sx={{ p: 1, minWidth: 300 }}>
                <Box display="flex" flexDirection="column" gap={1}>
                  {channelList.length > 1 && (
                    <SelectDropdown
                      optionsData={channelList}
                      selectedValue={interveneFilters?.channelObj}
                      placeholder="Select Channel"
                      label="Select Channel"
                      id="select-bot"
                      OptionLabel="channel_number"
                      OptionValue="channel_number"
                      handleSelect={(e) => {
                        setInterveneFilters({
                          ...interveneFilters,
                          channelObj: e,
                          botNumber: e?.channel_number,
                        });
                      }}
                      isClearable={true}
                      addOptionLabel={['app_name']}
                    />
                  )}
                  <ChatBox />
                  {/* <Box display="flex" justifyContent="flex-end">
                    <IconButton size="small" onClick={() => setShowChatBox(false)}>
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  </Box> */}
                </Box>
              </Paper>
            </Snackbar>
          </Grid>
          {/* <Box className="button-row">
            <span style={{ cursor: 'pointer' }}>
              <LocalPhoneIcon
                onClick={() => {
                  setModalShow_call(true);
                  setShowChatBox(false);
                }}
                sx={{ cursor: 'pointer', fontSize: 20 }}
                color="primary"
              />
              <SendIcon
                onClick={() => {
                  setModalShow_temp(true);
                  setShowChatBox(false);
                }}
                sx={{ cursor: 'pointer', fontSize: 20 }}
                color="primary"
              />
              {showChatBox ? (
                <CloseIcon
                  onClick={() => setShowChatBox(!showChatBox)}
                  sx={{ cursor: 'pointer', fontSize: 20 }}
                  color="primary"
                />
              ) : (
                <MessageIcon
                  onClick={() => setShowChatBox(!showChatBox)}
                  sx={{ cursor: 'pointer', fontSize: 20 }}
                  color="primary"
                />
              )}
            </span>
          </Box> */}
        </Grid>
      )}
      {showQuickTempModal && (
        <ModalForms
          show={showQuickTempModal}
          handleClose={() => setShowQuickTempModal(false)}
          modalHeader="Quick Template"
          modalId="calling"
          size="md"
          modalBody={
            <QuickTemplateModal
              quickTemplates={leadFormTemplate}
              setShowQuickTempModal={setShowQuickTempModal}
            />
          }
        />
      )}
      {modalShow_temp && (
        <ModalForms
          show={modalShow_temp}
          handleClose={() => setModalShow_temp(false)}
          modalHeader="Send Templates"
          modalId="template_modal"
          size="md"
          modalBody={<SendTemplateModal />}
        />
      )}
      {modalShow_call && (
        <ModalForms
          show={modalShow_call}
          handleClose={() => setModalShow_call(false)}
          modalHeader="Quick Call"
          modalId="calling"
          size="sm"
          modalBody={<CallingModal userDetails={userDetails} />}
        />
      )}
      {openValidationModal && (
        <ModalForms
          show={openValidationModal}
          handleClose={() => setOpenValidationModal(false)}
          modalHeader="Missing Fields"
          modalId="MissingFields"
          size="md"
          modalBody={
            <>
              {missingFields?.map((item, index) => (
                <Box
                  key={index}
                  sx={{
                    bgcolor: item?.isRequired ? '#f7dfdf' : '#fff3cd',
                    color: item?.isRequired ? '#664d03' : '#664d03',
                    p: 1.5,
                    mb: 1,
                    borderRadius: 1,
                    fontSize: '0.9rem',
                    fontWeight: 500,
                  }}
                >
                  {item?.keyName}
                </Box>
              ))}
            </>
          }
          modalFooter={
            <Box display="flex" justifyContent="flex-end" gap={2}>
              <Button
                onClick={() => setOpenValidationModal(false)}
                variant="outlined"
                color="primary"
              >
                Fill
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  setOpenValidationModal(false);
                  saveForms();
                }}
                disabled={Object.keys(validationErrors)?.length > 0}
              >
                Save changes
              </Button>
            </Box>
          }
        />
      )}
      {audioModalShow && (
        <ModalForms
          show={audioModalShow}
          handleClose={() => setAudioModalShow(false)}
          modalHeader="Recordings"
          modalId="Recordings"
          size="lg"
          modalBody={<KnowlarityModal />}
        />
      )}

      {dispositionModalShow && (
        <ModalForms
          show={dispositionModalShow}
          handleClose={() => setDispositionModalShow(false)}
          modalHeader="Add Disposition"
          modalId="addDisposition"
          size="md"
          backdrop={false}
          modalBody={<DispositionModal />}
          modalFooter={
            <Box display="flex" justifyContent="flex-end" gap={2}>
              <Button variant="contained" onClick={() => saveCallDataObj()}>
                Save
              </Button>
              {/* {isTimerActive && <span>Auto-submitting in {timerForSaveCdr} seconds...</span>} */}
            </Box>
          }
        />
      )}
      {/* </Box>
      )} */}
    </Box>
    // </>
  );
}

export default LeadWebForm;

// import React, { useEffect, useState } from 'react';
// import APIService from '../../Services/APIService';
// import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
// import {
//   B2b2cFormErrorAtom,
//   dynamicLeadFormAtom,
//   formEnableDisableAtom,
//   knowlarityApiResponseAtom,
//   leadAllCountsAtom,
//   leadDetailObjAtom,
//   leadFormQuickTemplateAtom,
//   phoneNumberAllLeadsAtom,
//   referenceFieldAtom,
//   userInfoByNumberAtom,
//   userInfoFormEnableDisableAtom,
//   userRawLeadFormDataAtom,
// } from '../../Services/_states/LeadForm';
// import {
//   channelListAtom,
//   interveneFilterAtom,
//   userDetailAtom,
//   userInformationAtom,
// } from '../../Services/_states';
// import SweetAlert from '../Shared/Notification';
// import ChatBox from './chatBox.tsx';
// import { QuickTemplateModal } from './QuickTemplateModal/quickTemplateModal';
// import { ConstantActions, LeadFormActions } from '../../Services/_actions';
// import { CallingModal } from '../Modals/CallingModal/CallingModal';
// import SendTemplateModal from '../Modals/SendTemplateModal';
// import { InterveneActions } from '../../Services/_actions/Intervene/intervene.actions';
// import { DispositionModal } from '../Modals/DispositionModal';
// import RecordingTimer from './RecordingTimer';
// import KnowlarityModal from '../Modals/KnowlarityModal/index.tsx';
// import SelectDropdown from '../Shared/SelectDropdown';
// import { useSnackBar } from '../FlowBuilder/Common/SnackBar/index.tsx';
// import {
//   Box,
//   Button,
//   Alert as MUIAlert,
//   Grid,
//   Typography,
//   Paper,
//   Snackbar,
//   IconButton,
//   useMediaQuery,
// } from '@mui/material';
// import ModalForms from '../../components/Shared/Modals';
// import { validateFormFieldValue } from '../Leads/DynamicFormFields/helper.ts';
// import { isValidNumber } from '../../utils/helper';
// import Header from './Header.tsx';
// import MobileLeadLayout from './MobileLeadLayout.tsx';
// import LeadsSection from './LeadsSection.tsx';
// import DetailsSection from './DetailsSection.tsx';
// import UserSection from './UserSection.tsx';
// import { useParams } from 'react-router';

// function LeadWebForm() {
//   const leadFormActions = LeadFormActions();
//   const constantActions = ConstantActions();
//   const interveneActions = InterveneActions();
//   const { showSnackBar } = useSnackBar();
//   const channelList = useRecoilValue(channelListAtom);
//   const [interveneFilters, setInterveneFilters] = useRecoilState(interveneFilterAtom);
//   const [dynamicLeadForm, setDynamicLeadForm] = useRecoilState(dynamicLeadFormAtom);
//   const setReferences = useSetRecoilState(referenceFieldAtom);
//   const [userDetails, setUserDetails] = useRecoilState(userDetailAtom);
//   const loggedInUser = useRecoilValue(userInformationAtom);
//   const setleadCounts = useSetRecoilState(leadAllCountsAtom);
//   const [formEnable, setFormEnable] = useRecoilState(formEnableDisableAtom);
//   const [leadDetails, setLeadDetail] = useRecoilState(leadDetailObjAtom);
//   const [validationErrors, setValidationErrors] = useRecoilState(B2b2cFormErrorAtom);
//   const [userDetailByNumber, setUserDetailByNumber] = useRecoilState(userInfoByNumberAtom);
//   const [userInfoFormEnable, setUserInfoFormEnable] = useRecoilState(userInfoFormEnableDisableAtom);
//   const knowlarityApiResData = useRecoilValue(knowlarityApiResponseAtom);
//   const [showQuickTempModal, setShowQuickTempModal] = useState(false);
//   const [modalShow_temp, setModalShow_temp] = useState(false);
//   const [modalShow_call, setModalShow_call] = useState(false);
//   const [leadFormTemplate, setLeadFormTemplate] = useRecoilState(leadFormQuickTemplateAtom);
//   const [showChatBox, setShowChatBox] = useState(false);
//   const [showNotepad, setShowNotepad] = useState(true);
//   const [missingFields, setMissingFields] = useState([]);
//   const [openValidationModal, setOpenValidationModal] = useState(false);
//   const [audioModalShow, setAudioModalShow] = React.useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [dispositionModalShow, setDispositionModalShow] = useState(false);
//   const [formDataLoading, setFormDataLoading] = useState(false);
//   const [userRawLeadData, setUserRawLeadData] = useRecoilState(userRawLeadFormDataAtom);
//   const [paginatedAllLeadsData, setPaginatedAllLeadsData] = useRecoilState(phoneNumberAllLeadsAtom);
//   const [dynamicFormData, setDynamicFormData] = useState({});
//   const [fieldErrors, setFieldErrors] = useState({});
//   const [statusUpdate, setStatusUpdate] = useState({});
//   const [searchValue, setSearchValue] = useState('');

//   const { phone_number, leadId } = useParams();
//   const leadIds = leadDetails?.id || userDetailByNumber?.leadId || leadId || '';
//   const [expanded, setExpanded] = useState(false);
//   const [subExpanded, setSubExpanded] = useState(false);
//   const isMobile = useMediaQuery('(max-width:768px)');

//   // Handle phone number search
//   const handleSearch = async (e) => {
//     try {
//       const leadWebFormData = JSON.parse(localStorage.getItem('leadWebFormData') || '{}');

//       if (!e || e.trim() === '') {
//         setSearchValue('');
//         setLeadDetail({});
//         setUserDetails({});
//         setDynamicFormData({});
//         setDynamicLeadForm({});

//         if (leadWebFormData?.campaign?.proposal_id && leadWebFormData?.webForm?.leads_form_id) {
//           setUserDetailByNumber({
//             leadform_Id: leadWebFormData?.webForm?.leads_form_id,
//             campaign_id: leadWebFormData?.campaign?.proposal_id,
//           });
//           getCampaignLeadAliasData(leadWebFormData.campaign.proposal_id);
//         } else {
//           setUserDetailByNumber({});
//         }

//         if (leadWebFormData) {
//           leadWebFormData.phoneNumber = '';
//           localStorage.setItem('leadWebFormData', JSON.stringify(leadWebFormData));
//         }
//         return;
//       }

//       if ((/^\d+$/.test(e) && e?.length <= 13) || !e) {
//         setDynamicFormData({});
//         setSearchValue(e);
//         setUserDetails({});
//         if (leadWebFormData) {
//           leadWebFormData.phoneNumber = e;
//           localStorage.setItem('leadWebFormData', JSON.stringify(leadWebFormData));
//         }
//       }

//       if (isValidNumber(e) && e?.length >= 10 && e?.length <= 13) {
//         let res = await leadFormActions.getDetailsByNumber(e);

//         if (res?.status === 200) {
//           if (res?.data === 'Not found') {
//             showSnackBar('User not found', 'warning');
//             if (leadWebFormData?.campaign?.proposal_id) {
//               getCampaignLeadAliasData(leadWebFormData.campaign.proposal_id);
//             }
//             return;
//           }

//           // Process the response data
//           let data = { ...res?.data };

//           // Set lead details immediately with ID
//           setLeadDetail({
//             ...data,
//             id: data.id || data.lead_id,
//           });

//           let updateData = [...(data?.data || [])];
//           updateData?.forEach((element) => {
//             if (element?.column_name === 'supplier_id') {
//               data['supplier_id'] = element['value'] || '';
//             }
//             if (element?.column_name === 'city') {
//               data['city'] = element['value'] || '';
//             }
//             if (element?.column_name === 'area') {
//               data['area'] = element['value'] || '';
//             }
//           });

//           setUserRawLeadData({ ...data, data: updateData });

//           const enrichedData = {
//             ...data,
//             leadform_Id: leadWebFormData?.webForm?.leads_form_id || '',
//             campaign_id: leadWebFormData?.campaign?.proposal_id || '',
//             leadId: leadId,
//             phone_number: e,
//           };
//           setUserDetailByNumber(enrichedData);

//           // Wait a bit to ensure form structure is loaded, then populate
//           setTimeout(() => {
//             populateFormWithData(res.data);
//           }, 300);

//         } else {
//           showSnackBar('Error occurred', 'warning');
//         }

//         setUserDetails({ phone_number: e });
//         if (leadWebFormData) {
//           leadWebFormData.phoneNumber = e;
//           localStorage.setItem('leadWebFormData', JSON.stringify(leadWebFormData));
//         }
//       }
//     } catch (error) {
//       console.error('handleSearch error:', error);
//       showSnackBar(error?.toString() || 'An unexpected error occurred', 'error');
//     }
//   };

//   // Separate function to populate form with data
//   const populateFormWithData = (leadData) => {
//     try {
//       if (!leadData || !leadData.data) {
//         console.warn('No lead data to populate');
//         return;
//       }

//       console.log('Populating form with lead data:', leadData);

//       // Get current form structure
//       const currentForm = { ...dynamicFormData };
//       if (!currentForm || Object.keys(currentForm).length === 0) {
//         console.warn('Form structure not loaded yet, using dynamicLeadForm');
//         const altForm = { ...dynamicLeadForm };
//         if (Object.keys(altForm).length === 0) {
//           console.error('No form structure available');
//           return;
//         }
//         // Use the alternate form
//         populateWithStructure(altForm, leadData.data);
//         return;
//       }

//       populateWithStructure(currentForm, leadData.data);

//     } catch (err) {
//       console.error('Error populating form:', err);
//     }
//   };

//   const populateWithStructure = (formStructure, dataArray) => {
//     // Create a map of field values from the data
//     const valueMap = new Map();
//     dataArray.forEach((item) => {
//       if (item.key_name) {
//         valueMap.set(item.key_name, item);
//       }
//     });

//     console.log('Value map created with', valueMap.size, 'entries');

//     // Update each group's fields with values
//     const updatedForm = {};
//     Object.entries(formStructure).forEach(([groupTitle, fields]) => {
//       if (!Array.isArray(fields)) {
//         console.warn(`Group ${groupTitle} is not an array:`, fields);
//         updatedForm[groupTitle] = [];
//         return;
//       }

//       updatedForm[groupTitle] = fields.map((field) => {
//         const sourceData = valueMap.get(field.key_name);
//         if (sourceData) {
//           console.log(`Populating ${field.key_name} with value:`, sourceData.value);
//           return {
//             ...field,
//             value: sourceData.value || field.value || '',
//             status_config: sourceData.status_config || field.status_config || null,
//             entity_data: sourceData.entity_data || field.entity_data || null,
//           };
//         }
//         return field;
//       });
//     });

//     console.log('Updated form structure:', Object.keys(updatedForm));
//     setDynamicFormData(updatedForm);
//     setDynamicLeadForm(updatedForm);
//   };

//   const validateFormData = () => {
//     let data = [];
//     Object.values(dynamicFormData || {}).forEach((groupItems) => {
//       if (Array.isArray(groupItems)) {
//         data = data.concat(groupItems);
//       }
//     });
//     const filteredData = data.filter((item) => !Boolean(item?.is_static_column));

//     let missingFields = [];
//     let errors = {};

//     for (let i in filteredData) {
//       if (!filteredData[i]?.value && filteredData[i]?.key_name !== 'Q2. Designation') {
//         if (filteredData[i]?.isRequired) {
//           errors[filteredData[i]?.key_name] = 'This Field is required';
//           missingFields.push({ keyName: filteredData[i]?.key_name, isRequired: true });
//         } else {
//           missingFields.push({ keyName: filteredData[i]?.key_name, isRequired: false });
//         }
//       }
//     }

//     setValidationErrors(errors);
//     setMissingFields(missingFields);

//     if (missingFields?.length > 0) {
//       setOpenValidationModal(true);
//     } else {
//       saveForms();
//     }
//   };

//   const findTitleById = (id, options) => {
//     const item = options?.find((item) => item.id === id);
//     return item?.title || 'Details';
//   };

//   const groupLeadItems = (leadArray, groupOptions) => {
//     const grouped = {};

//     if (!Array.isArray(leadArray)) {
//       console.error('leadArray is not an array:', leadArray);
//       return {};
//     }

//     leadArray.forEach((item) => {
//       if (!item) return;

//       const title = findTitleById(item.groupId, groupOptions);
//       if (!grouped[title]) {
//         grouped[title] = [];
//       }
//       grouped[title].push(item);
//     });

//     return grouped;
//   };

//   const getCampaignLeadAliasData = async (campaignId) => {
//     setFormDataLoading(true);
//     try {
//       const res = await leadFormActions.getFormsByCampaignId(campaignId);
//       const formId = userDetailByNumber?.leadform_Id;
//       const data = res?.data?.[formId];

//       if (!data) {
//         console.warn('Invalid Form Id');
//         setFormDataLoading(false);
//         return;
//       }

//       const leadItems = Object.values(data.leads_form_items || {});
//       const groupOptions = data.group_options || [];
//       const groupedForm = groupLeadItems(leadItems, groupOptions);

//       console.log('Loaded form structure:', Object.keys(groupedForm));

//       setLeadFormTemplate(data.templates || []);
//       setDynamicLeadForm(groupedForm);
//       setDynamicFormData(groupedForm);
//     } catch (error) {
//       console.error('Error loading campaign data:', error);
//       SweetAlert('Error loading form', 'error');
//     } finally {
//       setFormDataLoading(false);
//     }
//   };

//   const handleFieldChange = (index, value, groupTitle) => {
//     const updatedData = { ...dynamicFormData };
//     const groupForm = [...(updatedData[groupTitle] || [])];

//     if (!groupForm[index]) {
//       console.error('Field not found at index', index, 'in group', groupTitle);
//       return;
//     }

//     let updatedField = { ...groupForm[index], value: value };

//     if (value && typeof value === 'object' && value?.collection === 'entity') {
//       updatedField = { ...updatedField, entity_data: value ?? null, value: value?.value ?? '' };
//     } else if (
//       updatedField?.statusOption === 'is_status' ||
//       updatedField?.statusOption === 'is_sub_status'
//     ) {
//       if (updatedField?.statusOption === 'is_status') {
//         updatedField = {
//           ...updatedField,
//           status_config: value ?? null,
//           value: value?.status_name ?? '',
//         };
//       } else if (updatedField?.statusOption === 'is_sub_status') {
//         updatedField = { ...updatedField, status_config: value ?? null, value: value?.name ?? '' };
//       }
//       setStatusUpdate((prev) => {
//         if (updatedField?.statusOption === 'is_status') {
//           return {
//             ...prev,
//             status: {
//               ...prev.status,
//               [updatedField.key_name]: {
//                 status_id: value?.status_id ?? '',
//                 status_name: value?.status_name ?? '',
//                 type_of_status: value?.type_of_status ?? '',
//                 status: value?.status_name ?? '',
//               },
//             },
//           };
//         }
//         if (updatedField?.statusOption === 'is_sub_status') {
//           return {
//             ...prev,
//             sub_status: {
//               ...(prev?.sub_status ?? {}),
//               [updatedField.key_name]: {
//                 sub_status_id: value?.sub_status_id ?? '',
//                 sub_status_name: value?.name ?? '',
//                 type_of_status: value?.type_of_status ?? updatedField?.key_name ?? '',
//                 status_id: value?.status_id ?? '',
//                 status_name: value?.status_name ?? '',
//               },
//             },
//           };
//         }
//       });
//     }

//     groupForm[index] = updatedField;
//     updatedData[groupTitle] = [...groupForm];
//     setDynamicFormData(updatedData);

//     const errorMsg = validateFormFieldValue(updatedField, value);
//     if (errorMsg) {
//       setFieldErrors((prev) => ({ ...prev, [`${groupTitle}_${index}`]: errorMsg }));
//     } else {
//       setFieldErrors((prev) => {
//         const { [`${groupTitle}_${index}`]: _, ...rest } = prev;
//         return { ...rest };
//       });
//     }
//   };

//   const updateStatusInLoop = async (leadIds) => {
//     if (!leadIds) return;

//     try {
//       const statusPayloads = [
//         ...Object.values(statusUpdate?.status ?? {}),
//         ...Object.values(statusUpdate?.sub_status ?? {}),
//       ]
//         ?.filter(
//           (item) => Boolean(item) && item?.status_id && (item?.status_name || item?.sub_status_name)
//         )
//         ?.map((item) => ({
//           ...item,
//           id: leadIds,
//         }));

//       if (statusPayloads?.length === 0) {
//         return;
//       }

//       const results = await Promise.allSettled(
//         statusPayloads.map((payload) => leadFormActions.updateLeadStatusDate(payload))
//       );

//       results.forEach((res, idx) => {
//         const status = statusPayloads[idx];
//         const label = status.status_name || status.sub_status_name || 'unknown';

//         if (res.status === 'fulfilled' && res.value?.status === 200) {
//           // Success
//         } else {
//           console.error(`❌ Failed to update ${label}`, res);
//         }
//       });
//     } catch (err) {
//       console.error('Unexpected error in updateStatusInLoop:', err);
//     }
//   };

//   const uploadFileInS3 = async (files) => {
//     let s3Link = '';
//     try {
//       const file = files[0];
//       if (file) {
//         const formDataToUpload = new FormData();
//         formDataToUpload.append('file', file);
//         let resp = await constantActions.uploadFileS3Bucket(formDataToUpload);
//         if (resp?.status === 200 && resp?.data?.data) {
//           s3Link = resp?.data?.data?.url ?? '';
//         }
//       }
//     } catch (error) {
//       s3Link = '';
//       console.error('Error uploading file:', error);
//     }
//     return s3Link;
//   };

//   const saveForms = async () => {
//     setIsLoading(true);

//     const phone = userDetailByNumber?.phone_number || userDetails?.phone_number;
//     if (!phone) {
//       SweetAlert('Phone number is required', 'error');
//       setIsLoading(false);
//       return;
//     }

//     const currentLeadId = leadDetails?.id || userDetailByNumber?.leadIds || '';
//     const formId = userDetailByNumber?.leadform_Id;

//     if (!formId) {
//       SweetAlert('Form ID is missing', 'error');
//       setIsLoading(false);
//       return;
//     }

//     let allFields = [];
//     Object.values(dynamicFormData).forEach((group) => {
//       if (Array.isArray(group)) {
//         allFields = allFields.concat(group);
//       }
//     });

//     const errors = {};
//     const missingFields = [];
//     allFields.forEach((item) => {
//       if (item.isRequired && !item.value) {
//         errors[item.key_name] = 'This field is required';
//         missingFields.push(item.key_name);
//       }
//     });

//     if (missingFields.length > 0) {
//       setValidationErrors(errors);
//       setMissingFields(missingFields);
//       setOpenValidationModal(true);
//       setIsLoading(false);
//       return;
//     }

//     const updatedField = allFields?.filter((item) => !Boolean(item?.is_static_column));

//     const entries = await Promise.all(
//       updatedField?.map(async (item) => {
//         if (item.file?.length) {
//           const fileUrl = await uploadFileInS3(item.file);
//           return { key_name: item?.key_name, value: fileUrl };
//         }
//         return { key_name: item?.key_name, value: item.value };
//       })
//     );

//     const data = {
//       supplier_id: userDetailByNumber?.supplier_id?.toString() || '',
//       city: userDetailByNumber?.city || '',
//       area: userDetailByNumber?.area || '',
//       phone_number: phone,
//       supplier_name: userDetailByNumber?.entity_name || '',
//       contact_name: userDetailByNumber?.person_name || '',
//       leads_form_entries: entries,
//       internal_comment: leadDetails?.internal_comment || '',
//     };

//     try {
//       const endpoint = currentLeadId
//         ? `v0/ui/leads/${formId}/insert_lead?lead_id=${currentLeadId}`
//         : `v0/ui/leads/${formId}/insert_lead`;

//       const res = await APIService.post(endpoint, data);

//       if (res?.status === 200) {
//         if (res.data?.data?.lead_id && !currentLeadId) {
//           setLeadDetail((prev) => ({ ...prev, id: res.data.data.lead_id }));
//         }

//         await updateStatusInLoop(currentLeadId || res.data?.data?.lead_id);

//         showSnackBar('Lead saved successfully', 'success');
//       } else {
//         showSnackBar('Failed to save lead', 'error');
//       }
//     } catch (err) {
//       console.error('Save error:', err);
//       showSnackBar('Something went wrong', 'error');
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const submitForms = async () => {
//     await leadFormActions.updateQcStatus(leadDetails);
//   };

//   const editForms = () => {
//     setFormEnable(!formEnable);
//   };

//   const updateUserDetail = async () => {
//     if (!userDetailByNumber) {
//       showSnackBar('User details are missing', 'error');
//       return;
//     }
//     const data = {
//       company_id: userDetailByNumber?.company_id,
//       data: userRawLeadData?.data,
//       form_id: userDetailByNumber?.form_id,
//       phone_number: userDetailByNumber?.phone_number,
//     };

//     try {
//       let res;
//       if (userRawLeadData?.isCreateNewUser) {
//         res = await leadFormActions.createUserDetail(data);
//         if (res?.status === 200) {
//           setUserInfoFormEnable(true);
//           setUserRawLeadData({ ...userRawLeadData, isCreateNewUser: false });
//           showSnackBar('User Created successfully', 'success');
//         } else if (res?.data?.data?.general_error) {
//           showSnackBar(res.data.data.general_error, 'error');
//         } else {
//           showSnackBar('User not created successfully', 'error');
//         }
//       } else {
//         res = await leadFormActions.updateUserDetail(data);
//         if (res?.status === 200) {
//           showSnackBar('Information updated successfully', 'success');
//           setUserInfoFormEnable(true);
//         } else if (res?.data?.data?.general_error) {
//           showSnackBar(res.data.data.general_error, 'error');
//         } else {
//           showSnackBar('Information not updated successfully', 'error');
//         }
//       }
//     } catch (error) {
//       showSnackBar('Something went wrong', 'error');
//     }
//   };

//   const getAllChannels = async () => {
//     await interveneActions?.getAllChannels();
//   };

//   // Initialize search value from URL param or existing data
//   useEffect(() => {
//     if (phone_number) {
//       setSearchValue(phone_number);
//       handleSearch(phone_number);
//     } else if (userDetailByNumber?.phone_number) {
//       setSearchValue(userDetailByNumber.phone_number);
//     } else if (userDetails?.phone_number) {
//       setSearchValue(userDetails.phone_number);
//     }
//   }, [phone_number]);

//   // Initialize form data from localStorage on mount
//   useEffect(() => {
//     try {
//       const leadWebFormData = JSON.parse(localStorage.getItem('leadWebFormData') || '{}');

//       if (leadWebFormData?.campaign?.proposal_id && leadWebFormData?.webForm?.leads_form_id) {
//         setUserDetailByNumber({
//           leadform_Id: leadWebFormData.webForm.leads_form_id,
//           campaign_id: leadWebFormData.campaign.proposal_id,
//           phone_number: leadWebFormData.phoneNumber || '',
//         });

//         if (leadWebFormData.campaign.proposal_id) {
//           getCampaignLeadAliasData(leadWebFormData.campaign.proposal_id);
//         }

//         if (leadWebFormData.phoneNumber && !phone_number) {
//           setTimeout(() => {
//             setSearchValue(leadWebFormData.phoneNumber);
//             handleSearch(leadWebFormData.phoneNumber);
//           }, 800);
//         }
//       }
//     } catch (error) {
//       console.error('Error loading form data:', error);
//     }
//   }, []);

//   useEffect(() => {
//     if (channelList?.length >= 1) {
//       setInterveneFilters({
//         ...interveneFilters,
//         channelObj: channelList[0],
//         botNumber: channelList[0]['channel_number'],
//       });
//     }
//   }, [channelList]);

//   useEffect(() => {
//     if (dynamicLeadForm && Object.keys(dynamicLeadForm).length > 0) {
//       setDynamicFormData(dynamicLeadForm);
//     }
//   }, [dynamicLeadForm]);

//   useEffect(() => {
//     getAllChannels();
//   }, []);

//   // Process and display form when campaign/form is selected
//   useEffect(() => {
//     if (userDetailByNumber?.campaign_id && userDetailByNumber?.leadform_Id) {
//       if (!dynamicFormData || Object.keys(dynamicFormData).length === 0) {
//         getCampaignLeadAliasData(userDetailByNumber.campaign_id);
//       }
//     }
//   }, [userDetailByNumber?.campaign_id, userDetailByNumber?.leadform_Id]);

//   const fetchVarient = (type) => {
//     switch (type) {
//       case 'AGENT_CALL':
//       case 'AGENT_ANSWER':
//       case 'CUSTOMER_CALL':
//         return 'warning';
//       case 'CUSTOMER_ANSWER':
//         return 'success';
//       case 'HANGUP':
//         return 'danger';
//       default:
//         return '';
//     }
//   };

//   function generateUUIDWithTimestamp() {
//     const timestamp = Date.now().toString(16);
//     return `${timestamp.slice(0, 8)}-xxxx-4xxx-yxxx-${timestamp.slice(8)}xxxx`.replace(
//       /[xy]/g,
//       function (c) {
//         const r = (Math.random() * 16) | 0,
//           v = c === 'x' ? r : (r & 0x3) | 0x8;
//         return v.toString(16);
//       }
//     );
//   }

//   const saveCallDataObj = async () => {
//     const currentTime = new Date();
//     if (!userDetails?.phone_number) {
//       SweetAlert('Phone number is not found', 'warning');
//       return 0;
//     }
//     if (!loggedInUser?.mobile) {
//       SweetAlert('Agent number is not found', 'warning');
//       return 0;
//     }

//     let data = {
//       ...knowlarityApiResData,
//       dispnumber: '',
//       timezone_offset: '+0000',
//       business_call_type: 'Manual Dial',
//       caller_id: `+91${userDetails?.phone_number || ''}`,
//       Call_Type: 'Outgoing',
//       uuid: generateUUIDWithTimestamp(),
//       call_duration: 0,
//       destination: `+91${loggedInUser?.mobile || ''}`,
//       end_time: currentTime,
//       resource_url: '',
//       type: 'CDR',
//       start_time: currentTime,
//       agent_number: loggedInUser?.mobile || '',
//       end_customer_number: userDetails?.phone_number || '',
//     };
//     await leadFormActions.postInterveneCdrData(data);
//   };

//   return (
//     <Box>
//       {isMobile ? (
//         <>
//           <Box mb={2}>
//             <Header />
//           </Box>
//           <MobileLeadLayout
//             dynamicFormData={dynamicFormData}
//             handleFieldChange={handleFieldChange}
//             fieldErrors={fieldErrors}
//             loggedInUser={loggedInUser}
//             phoneNumber={userDetailByNumber?.phone_number || userDetails?.phone_number || ''}
//             formEnable={formEnable}
//             isLoading={isLoading}
//             editForms={editForms}
//             validateFormData={validateFormData}
//             setShowQuickTempModal={setShowQuickTempModal}
//             setDispositionModalShow={setDispositionModalShow}
//             leadFormTemplate={leadFormTemplate}
//             setAudioModalShow={setAudioModalShow}
//             setModalShow_call={setModalShow_call}
//             setModalShow_temp={setModalShow_temp}
//             setShowChatBox={setShowChatBox}
//             showChatBox={showChatBox}
//             searchValue={searchValue}
//             handleSearch={handleSearch}
//             currentLead={leadDetails}
//             onLeadSelect={(lead) => {
//               console.log('Lead selected:', lead);
//               setLeadDetail(lead);
//               if (lead?.data) {
//                 populateFormWithData(lead);
//               }
//             }}
//             campaignId={userDetailByNumber?.campaign_id || ''}
//             leadFormId={userDetailByNumber?.leadform_Id || ''}
//           />
//         </>
//       ) : (
//         <Box>
//           <Box mb={2}>
//             <Header />
//           </Box>
//           {knowlarityApiResData?.type && (
//             <Box mb={2}>
//               <MUIAlert severity={fetchVarient(knowlarityApiResData?.type)}>
//                 {knowlarityApiResData?.type === 'AGENT_CALL' ? (
//                   `Call Successfully Placed to Agent:- ${knowlarityApiResData?.agent_number}`
//                 ) : knowlarityApiResData?.type === 'AGENT_ANSWER' ? (
//                   `Call Received by Agent :- ${knowlarityApiResData?.customer_number}`
//                 ) : knowlarityApiResData?.type === 'CUSTOMER_CALL' ? (
//                   `Connecting Agent to Customer :- ${knowlarityApiResData?.customer_number}`
//                 ) : knowlarityApiResData?.type === 'CUSTOMER_ANSWER' ? (
//                   <>
//                     Call Connected :- {knowlarityApiResData?.customer_number} (<RecordingTimer />)
//                   </>
//                 ) : knowlarityApiResData?.type === 'HANGUP' ? (
//                   'Call Disconnected'
//                 ) : (
//                   ''
//                 )}
//               </MUIAlert>
//             </Box>
//           )}
//           <Grid container spacing={2}>
//             <Grid item sm={4}>
//               <LeadsSection />
//             </Grid>
//             <Grid item sx={{ transition: '0.1s' }} sm={showChatBox || showNotepad ? '4' : '8'}>
//               <DetailsSection
//                 formDataLoading={formDataLoading}
//                 dynamicFormData={dynamicFormData}
//                 loggedInUser={loggedInUser}
//                 handleFieldChange={handleFieldChange}
//                 fieldErrors={fieldErrors}
//                 formEnable={formEnable}
//                 userDetailByNumber={userDetailByNumber}
//                 userDetails={userDetails}
//                 isLoading={isLoading}
//                 validateFormData={validateFormData}
//                 editForms={editForms}
//                 leadFormTemplate={leadFormTemplate}
//                 setShowQuickTempModal={setShowQuickTempModal}
//                 setDispositionModalShow={setDispositionModalShow}
//                 showNotepad={showNotepad}
//                 setShowNotepad={setShowNotepad}
//                 showChatBox={showChatBox}
//                 setShowChatBox={setShowChatBox}
//               />
//             </Grid>

//             {showNotepad && (
//               <Grid
//                 item
//                 sm={4}
//                 sx={{ opacity: showChatBox || showNotepad ? 1 : 0, transition: 'all 1s ease' }}
//               >
//                 <UserSection
//                   updateUserDetail={updateUserDetail}
//                   setAudioModalShow={setAudioModalShow}
//                   setModalShow_call={setModalShow_call}
//                   setModalShow_temp={setModalShow_temp}
//                   setUserInfoFormEnable={setUserInfoFormEnable}
//                   userInfoFormEnable={userInfoFormEnable}
//                   setShowChatBox={setShowChatBox}
//                   showChatBox={showChatBox}
//                 />
//               </Grid>
//             )}
//           </Grid>
//         </Box>
//       )}
//       {showNotepad && !isMobile && (
//         <Grid className="chat-conversation position-relative">
//           <Grid
//             item
//             xs={12}
//             sm={6}
//             md={8}
//             lg={9}
//             className="chat-card position-absolute top-0 end-0"
//           >
//             <Snackbar
//               open={showChatBox}
//               autoHideDuration={3000}
//               onClose={() => setShowChatBox(false)}
//               anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
//               sx={{
//                 '&.MuiSnackbar-root': {
//                   top: '118px',
//                   right: '110px',
//                 },
//               }}
//             >
//               <Paper elevation={4} sx={{ p: 1, minWidth: 300 }}>
//                 <Box display="flex" flexDirection="column" gap={1}>
//                   {channelList.length > 1 && (
//                     <SelectDropdown
//                       optionsData={channelList}
//                       selectedValue={interveneFilters?.channelObj}
//                       placeholder="Select Channel"
//                       label="Select Channel"
//                       id="select-bot"
//                       OptionLabel="channel_number"
//                       OptionValue="channel_number"
//                       handleSelect={(e) => {
//                         setInterveneFilters({
//                           ...interveneFilters,
//                           channelObj: e,
//                           botNumber: e?.channel_number,
//                         });
//                       }}
//                       isClearable={true}
//                       addOptionLabel={['app_name']}
//                     />
//                   )}
//                   <ChatBox />
//                 </Box>
//               </Paper>
//             </Snackbar>
//           </Grid>
//         </Grid>
//       )}
//       {showQuickTempModal && (
//         <ModalForms
//           show={showQuickTempModal}
//           handleClose={() => setShowQuickTempModal(false)}
//           modalHeader="Quick Template"
//           modalId="calling"
//           size="md"
//           modalBody={
//             <QuickTemplateModal
//               quickTemplates={leadFormTemplate}
//               setShowQuickTempModal={setShowQuickTempModal}
//             />
//           }
//         />
//       )}
//       {modalShow_temp && (
//         <ModalForms
//           show={modalShow_temp}
//           handleClose={() => setModalShow_temp(false)}
//           modalHeader="Send Templates"
//           modalId="template_modal"
//           size="md"
//           modalBody={<SendTemplateModal />}
//         />
//       )}
//       {modalShow_call && (
//         <ModalForms
//           show={modalShow_call}
//           handleClose={() => setModalShow_call(false)}
//           modalHeader="Quick Call"
//           modalId="calling"
//           size="sm"
//           modalBody={<CallingModal userDetails={userDetails} />}
//         />
//       )}
//       {openValidationModal && (
//         <ModalForms
//           show={openValidationModal}
//           handleClose={() => setOpenValidationModal(false)}
//           modalHeader="Missing Fields"
//           modalId="MissingFields"
//           size="md"
//           modalBody={
//             <>
//               {missingFields?.map((item, index) => (
//                 <Box
//                   key={index}
//                   sx={{
//                     bgcolor: item?.isRequired ? '#f7dfdf' : '#fff3cd',
//                     color: item?.isRequired ? '#664d03' : '#664d03',
//                     p: 1.5,
//                     mb: 1,
//                     borderRadius: 1,
//                     fontSize: '0.9rem',
//                     fontWeight: 500,
//                   }}
//                 >
//                   {item?.keyName}
//                 </Box>
//               ))}
//             </>
//           }
//           modalFooter={
//             <Box display="flex" justifyContent="flex-end" gap={2}>
//               <Button
//                 onClick={() => setOpenValidationModal(false)}
//                 variant="outlined"
//                 color="primary"
//               >
//                 Fill
//               </Button>
//               <Button
//                 variant="contained"
//                 color="primary"
//                 onClick={() => {
//                   setOpenValidationModal(false);
//                   saveForms();
//                 }}
//                 disabled={Object.keys(validationErrors)?.length > 0}
//               >
//                 Save changes
//               </Button>
//             </Box>
//           }
//         />
//       )}
//       {audioModalShow && (
//         <ModalForms
//           show={audioModalShow}
//           handleClose={() => setAudioModalShow(false)}
//           modalHeader="Recordings"
//           modalId="Recordings"
//           size="lg"
//           modalBody={<KnowlarityModal />}
//         />
//       )}

//       {dispositionModalShow && (
//         <ModalForms
//           show={dispositionModalShow}
//           handleClose={() => setDispositionModalShow(false)}
//           modalHeader="Add Disposition"
//           modalId="addDisposition"
//           size="md"
//           backdrop={false}
//           modalBody={<DispositionModal />}
//           modalFooter={
//             <Box display="flex" justifyContent="flex-end" gap={2}>
//               <Button variant="contained" onClick={() => saveCallDataObj()}>
//                 Save
//               </Button>
//             </Box>
//           }
//         />
//       )}
//     </Box>
//   );
// }

// export default LeadWebForm;
